module.exports = __webpack_public_path__ + "img/rb.235cb267.svg";